import type {
  DocumentTemplateSummary,
  EncounterKind,
  EncounterSchema,
  SchemaDocumentRef,
} from '../config';

import { isBlockNoteTemplate, isProtocolTemplate } from './documentTypeRules';

export const isProtocolDocument = (
  reference: SchemaDocumentRef,
  templates: DocumentTemplateSummary[],
) =>
  isProtocolTemplate(reference.type) ||
  templates.some(
    (template) =>
      template.series_id === reference.template_series_id &&
      isProtocolTemplate(template.type),
  );

export const getSchemasUsingSeries = (
  schemas: EncounterSchema[],
  seriesId: string,
) =>
  schemas.filter((schema) =>
    schema.documents.some(
      (reference) => reference.template_series_id === seriesId,
    ),
  );

// Scribe does not expose the persisted kind yet; until it does, a schema with
// a protocol document counts as treatment.
export const getSchemaKind = (
  schema: EncounterSchema,
  templates: DocumentTemplateSummary[],
): EncounterKind =>
  schema.kind ??
  (schema.documents.some((reference) =>
    isProtocolDocument(reference, templates),
  )
    ? 'treatment'
    : 'consultation');

// A consultation whose documents are generated from the recording: it has no
// block note to fill while recording.
export const isConsultationWithoutBlockNotes = (
  schema: EncounterSchema,
  templates: DocumentTemplateSummary[],
) =>
  getSchemaKind(schema, templates) === 'consultation' &&
  !schema.documents.some(
    (reference) =>
      isProtocolDocument(reference, templates) &&
      templates.some(
        (template) =>
          template.series_id === reference.template_series_id &&
          isBlockNoteTemplate(template),
      ),
  );
